<section *ngIf="selectedView == 'grid' || selectedView == 'small-grid'" [ngClass]="{'small-grid': selectedView == 'small-grid'}">
  <div *ngIf="groupFeature && selectedTab == '0' || selectedTab == '2'" class="groupRow">
    <h4 class="typeName">{{'Group' | translate}} ({{deviceGroupListData.length}})</h4>
    <p-accordion (onOpen)="onTabOpen($event)">
      <p-accordion-panel [value]="i" *ngFor="let item of deviceGroupListData; let i=index;">
        <p-accordion-header>
          <div class="flex" *ngIf="pageloading">
            <a [routerLinkActive]="['is-active']" class="groupLink name">
              <div class="groupName flex">
                <div class="groupIcon">
                  <p-skeleton shape="circle" width="40px" height="40px"></p-skeleton>
                </div>
                <h5 style="margin-top: 12px !important;"><p-skeleton appearance="line" width="200px" height="14px"></p-skeleton></h5>
              </div>
            </a>
            <a class="groupLink info" style="margin-top: 12px !important;"><p-skeleton appearance="line" width="52px" height="14px"></p-skeleton></a>
          </div>
          <div class="flex" *ngIf="!pageloading">
            <a [routerLinkActive]="['is-active']" class="groupLink name">
              <div class="groupName">
                <div class="groupIcon {{item.data.status}}">
                  <i class="fa fa-sitemap" aria-hidden="true"></i>
                </div>
                <h5>{{item.data.name}}</h5>
              </div>
            </a>
            <div>
              <a class="groupLink info" (click)="triggerEdit(item.data.gId)" *ngIf="item.data.regionId == null || item.data.EditDevice === 1">
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </a>
              <a class="groupLink info" (click)="triggerDelete(item.data.gId)" *ngIf="item.data.regionId == null || item.data.EditDevice === 1">
                <i class="fa fa-trash" aria-hidden="true"></i>
              </a>
              <a routerLink="{{item.data.routeLink}}" [routerLinkActive]="['is-active']" class="groupLink info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="row" *ngIf="filterChildren(item.children,false).length <= 20 else deviceGroupListVirtualScroll">
            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12" *ngFor="let item of filterChildren(item.children,false); let i=index;">
              <p-blockUI [target]="pnl" *ngIf="item.data.isExpired && !this.isMsp" [blocked]="item.data.isExpired">
                <!-- <i class="fa fa-lock fa-5x"></i>
                <div class="tooltips" pTooltip="{{'No valid Plan or trial is available' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                </div> -->
                <button type="button" pButton (click)="displayisTrialDialog(item.data);" label="{{'Get Free Trial' | translate}}"
                        class="p-button-rounded" icon="fa fa-lock" *ngIf="item.data.canTrial && !this.isMsp"></button>
                <button type="button" pButton (click)="displayExpiredDialog(item.data);" label="{{'Locked' | translate}}"
                        class="p-button-rounded p-button-secondary" icon="fa fa-lock" *ngIf="!item.data.canTrial && !this.isMsp"></button>
              </p-blockUI>
              <p-blockUI [target]="pnl" *ngIf="!item.data.isExpired && companionAlert && item.data.protecting && item.data.status !== 'offline'" [blocked]="!item.data.isExpired && companionAlert && item.data.protecting && item.data.status !== 'offline'">
                <button type="button" pButton  (click)="routerCompanion();" label="{{'See Companion' | translate}}" class="p-button-rounded ui-button-danger" ></button>
                <div class="share-name">
                  <a [routerLink]="item.data.routeLink" translate style="text-decoration: underline !important;">click here for details.</a>
                </div>
              </p-blockUI>
              <p-panel #pnl class="device_blockUI" [ngClass]="{'trial_block': item.data.isExpired && item.data.canTrial, 'companion_block': !item.data.isExpired && companionAlert && item.data.protecting && item.data.status !== 'offline'}">
                <a [routerLink]="item.data.routeLink" class="device-link" [class.disabled]="item.data.isExpired ? true : item.data.protecting ? (item.data.status !== 'offline' ? true : null) : null">
                  <div class="device-content {{item.data.status}}">
                    <div class="device-basicInfo">
                      <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                        <!-- <img src="{{item.image}}" alt="" class="responsive-image"> -->
                        <div class="img-size">
                          <img class="responsive-image" [defaultImage]="'/assets/images/default_device.png'" [lazyLoad]="item.data.image" (error)="errorHandler($event)">
                          <!-- <img [hidden]="pageloading" (load)="onLoad()" src="{{item.data.image}}" onerror="this.src='/assets/images/default_device.png'"
                              class="responsive-image">
                          <img *ngIf="pageloading" src="/assets/images/default_device.png" alt="loading" class="responsive-image"> -->
                        </div>
                      </div>
                      <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                        <div class="device-title">
                          <div class="name">
                            <!-- <i class="fa {{item.icon}}" aria-hidden="true"></i> -->
                            <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': item.data.hardwarefault.faultLevelColor}"
                              *ngIf="item.data.hardwarefault && item.data.hardwarefault.isHardwareFault"></i>
                            <h5> {{item.data.name}}</h5>
                          </div>
                          <div class="badge badge-secondary hidden-sm">
                            <span>{{item.data.displayTag}}</span>
                          </div>
                        </div>
                        <div class="device-desc">{{item.data.desc | translate}}</div>
                      </div>
                    </div>
                    <div class="device-moreInfo" *ngIf="item.data.DeviceSubType == DeviceSubTypeMapping['UPS'] || item.data.DeviceSubType === DeviceSubTypeMapping['3-Phase UPS']">
                      <div class="device-battery {{item.data.batteryStatus}}">
                        <div class="device-icon" pTooltip="{{'Battery Capacity' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                          <p-progressBar [value]="item.data.batteryCapacity" [showValue]="false"></p-progressBar>
                          <i class="fa fa-battery-empty" aria-hidden="true"></i>
                        </div>
                        <span>{{item.data.batteryCapacity}} %</span>
                      </div>
                      <!-- 快到期判斷class=true -->
                      <div class="device-rbrd" *ngIf="item.data.btyReplacement && item.data.btyReplacement.BR_Rc_Date && item.data.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'companion_block': item.data.protecting && companionAlert && item.data.status !== 'offline' , 'alert-color': item.data.btyReplacement.expires}">
                        <div class="device-icon">
                          <i *ngIf="item.data.btyReplacement.expires" class="fa fa-bell" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
                            tooltipStyleClass="critical"></i>
                          <i *ngIf="!item.data.btyReplacement.expires" class="fa fa-calendar" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}"
                            tooltipPosition="bottom" tooltipStyleClass="tooltips_gary"></i>
                        </div>
                        <span>{{item.data.btyReplacement.BR_Rc_Date | date: preferenceService.dateFormat}}</span>
                      </div>
                      <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                      <div class="device-trial" *ngIf="!item.data.planActivate && !item.data.mspPlanActivate && !item.data.isExpired && item.data.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'companion_block': item.data.protecting && companionAlert && item.data.status !== 'offline' , 'alert-color': item.data.trialRemainDay <10}">
                        <div class="device-icon">
                          <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                            tooltipStyleClass="tooltips_gary"></i>
                        </div>
                        <span>{{item.data.trialRemainDay}}<span translate>days</span></span>
                      </div>
                    </div>
                    <div class="device-moreInfo" *ngIf="item.data.DeviceSubType == DeviceSubTypeMapping['ATS'] || item.data.DeviceSubType == DeviceSubTypeMapping['PDU'] || item.data.DeviceSubType == DeviceSubTypeMapping['nATS'] || item.data.DeviceSubType == DeviceSubTypeMapping['nPDU']">
                      <div class="device-current">
                        <div class="device-icon">
                          <i class="fa fa-bolt" aria-hidden="true" pTooltip="{{'Current' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary"></i>
                        </div>
                        <span>{{item.data.Cur}} A</span>
                      </div>
                      <div class="device-energy" *ngIf="item.data.DeviceSubType === DeviceSubTypeMapping['ATS'] || item.data.DeviceSubType === DeviceSubTypeMapping['PDU']">
                        <div class="device-icon">
                          <span class="material-icons" pTooltip="{{'Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                            model_training
                          </span>
                        </div>
                        <span *ngIf="item.data.Energy else noData_span">{{item.data.Energy}}</span> kWh
                      </div>
                      <div class="device-energyT" *ngIf="item.data.DeviceSubType === DeviceSubTypeMapping['nATS'] || item.data.DeviceSubType === DeviceSubTypeMapping['nPDU']">
                        <div class="device-icon">
                          <span class="material-icons" pTooltip="{{'Total Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                            model_training
                          </span>
                        </div>
                        <span *ngIf="item.data.EnergyT else noData_span">{{item.data.EnergyT}}</span> kWh
                      </div>
                      <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                      <div class="device-trial" *ngIf="!item.data.planActivate && !item.data.mspPlanActivate && !item.data.isExpired" [ngClass]="{'companion_block': item.data.protecting && companionAlert && item.data.status !== 'offline' , 'alert-color': item.data.trialRemainDay <10}">
                        <div class="device-icon">
                          <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                            tooltipStyleClass="tooltips_gary"></i>
                        </div>
                        <span>{{item.data.trialRemainDay}}<span translate>days</span></span>
                      </div>
                    </div>
                  </div>
                </a>
              </p-panel>
            </div>
          </div>
          <div class="row" *ngIf="filterChildren(item.children,false).length == 0">
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" *ngFor="let item of dataLoadingView">
              <div class="device-content" style="display: block !important;" *ngIf="pageloading">
                <div class="device-basicInfo">
                  <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                    <div>
                      <p-skeleton appearance="line" width="70px" height="70px">></p-skeleton>
                    </div>
                  </div>
                  <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                    <div class="device-title">
                      <div class="name">
                        <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 14, 'background-color': '#e9eef0'}"></p-skeleton>
                      </div>
                    </div>
                    <div class="device-desc">
                      <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                    </div>
                  </div>
                </div>
                <div class="device-moreInfo" style="display: block !important;">
                  <p-skeleton appearance="line" [theme]="{ 'width': '100%', 'height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </p-accordion-content>

        <ng-template #deviceGroupListVirtualScroll>
          <p-virtualscroller [items]="filterChildrenItem" [itemSize]="25" [showLoader]="true" [delay]="250" scrollHeight="550px" [style]="{ height: '550px' }">
              <ng-template #item let-item let-options="options">
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12">
                  <p-blockUI [target]="pnl" *ngIf="item.data.isExpired && !this.isMsp" [blocked]="item.data.isExpired">
                    <!-- <i class="fa fa-lock fa-5x"></i>
                    <div class="tooltips" pTooltip="{{'No valid Plan or trial is available' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                    </div> -->
                    <button type="button" pButton (click)="displayisTrialDialog(item.data);" label="{{'Get Free Trial' | translate}}"
                            class="p-button-rounded" icon="fa fa-lock" *ngIf="item.data.canTrial && !this.isMsp"></button>
                    <button type="button" pButton (click)="displayExpiredDialog(item.data);" label="{{'Locked' | translate}}"
                            class="p-button-rounded p-button-secondary" icon="fa fa-lock" *ngIf="!item.data.canTrial && !this.isMsp"></button>
                  </p-blockUI>
                  <p-panel #pnl class="device_blockUI" [ngClass]="{'trial_block': item.data.canTrial}">
                    <a [routerLink]="item.data.routeLink" class="device-link" [class.disabled]="item.data.isExpired ? true : null">
                      <div class="device-content {{item.data.status}}">
                        <div class="device-basicInfo">
                          <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                            <!-- <img src="{{item.image}}" alt="" class="responsive-image"> -->
                            <div class="img-size">
                              <img class="responsive-image" [defaultImage]="'/assets/images/default_device.png'" [lazyLoad]="item.data.image" (error)="errorHandler($event)">
                              <!-- <img [hidden]="pageloading" (load)="onLoad()" src="{{item.data.image}}" onerror="this.src='/assets/images/default_device.png'"
                                  class="responsive-image">
                              <img *ngIf="pageloading" src="/assets/images/default_device.png" alt="loading" class="responsive-image"> -->
                            </div>
                          </div>
                          <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                            <div class="device-title">
                              <div class="name">
                                <!-- <i class="fa {{item.icon}}" aria-hidden="true"></i> -->
                                <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': item.data.hardwarefault.faultLevelColor}"
                                  *ngIf="item.data.hardwarefault && item.data.hardwarefault.isHardwareFault"></i>
                                <h5> {{item.data.name}}</h5>
                              </div>
                              <div class="badge badge-secondary hidden-sm">
                                <span>{{item.data.displayTag}}</span>
                              </div>
                            </div>
                            <div class="device-desc">{{item.data.desc | translate}}</div>
                          </div>
                        </div>
                        <div class="device-moreInfo" *ngIf="item.data.DeviceSubType === DeviceSubTypeMapping['UPS'] || item.data.DeviceSubType == DeviceSubTypeMapping['3-Phase UPS']">
                          <div class="device-battery {{item.data.batteryStatus}}">
                            <div class="device-icon" pTooltip="{{'Battery Capacity' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                              <p-progressBar [value]="item.data.batteryCapacity" [showValue]="false"></p-progressBar>
                              <i class="fa fa-battery-empty" aria-hidden="true"></i>
                            </div>
                            <span>{{item.data.batteryCapacity}} %</span>
                          </div>
                          <!-- 快到期判斷class=true -->
                          <div class="device-rbrd" *ngIf="item.data.btyReplacement && item.data.btyReplacement.BR_Rc_Date && item.data.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'alert-color': item.data.btyReplacement.expires}">
                            <div class="device-icon">
                              <i *ngIf="item.data.btyReplacement.expires" class="fa fa-bell" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
                                tooltipStyleClass="critical"></i>
                              <i *ngIf="!item.data.btyReplacement.expires" class="fa fa-calendar" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}"
                                tooltipPosition="bottom" tooltipStyleClass="tooltips_gary"></i>
                            </div>
                            <span>{{item.data.btyReplacement.BR_Rc_Date | date: preferenceService.dateFormat}}</span>
                          </div>
                          <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                          <div class="device-trial" *ngIf="!item.data.planActivate && !item.data.mspPlanActivate && !item.data.isExpired && item.data.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'alert-color': item.data.trialRemainDay <10}">
                            <div class="device-icon">
                              <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                                tooltipStyleClass="tooltips_gary"></i>
                            </div>
                            <span>{{item.data.trialRemainDay}}<span translate>days</span></span>
                          </div>
                        </div>
                        <div class="device-moreInfo" *ngIf="item.data.DeviceSubType == DeviceSubTypeMapping['ATS'] || item.data.DeviceSubType == DeviceSubTypeMapping['PDU'] || item.data.DeviceSubType == DeviceSubTypeMapping['nATS'] || item.data.DeviceSubType == DeviceSubTypeMapping['nPDU']">
                          <div class="device-current">
                            <div class="device-icon">
                              <i class="fa fa-bolt" aria-hidden="true" pTooltip="{{'Current' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary"></i>
                            </div>
                            <span>{{item.data.Cur}} A</span>
                          </div>
                          <div class="device-energy" *ngIf="item.data.DeviceSubType === DeviceSubTypeMapping['ATS'] || item.data.DeviceSubType === DeviceSubTypeMapping['PDU']">
                            <div class="device-icon">
                              <span class="material-icons" pTooltip="{{'Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                                model_training
                              </span>
                            </div>
                            <span *ngIf="item.data.Energy else noData_span">{{item.data.Energy}}</span> kWh
                          </div>
                          <div class="device-energyT" *ngIf="item.data.DeviceSubType === DeviceSubTypeMapping['nATS'] || item.data.DeviceSubType === DeviceSubTypeMapping['nPDU']">
                            <div class="device-icon">
                              <span class="material-icons" pTooltip="{{'Total Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                                model_training
                              </span>
                            </div>
                            <span *ngIf="item.data.EnergyT else noData_span">{{item.data.EnergyT}}</span> kWh
                          </div>
                          <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                          <div class="device-trial" *ngIf="!item.data.planActivate && !item.data.mspPlanActivate && !item.data.isExpired" [ngClass]="{'companion_block': item.data.protecting && companionAlert && item.data.status !== 'offline' , 'alert-color': item.data.trialRemainDay <10}">
                            <div class="device-icon">
                              <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                                tooltipStyleClass="tooltips_gary"></i>
                            </div>
                            <span>{{item.data.trialRemainDay}}<span translate>days</span></span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </p-panel>
                </div>
              </ng-template>
              <ng-template #loader let-options="options">
                  <div class="row" style="padding-right: 8px;">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" *ngFor="let item of dataLoadingView">
                      <div class="device-content" style="display: block !important;">
                        <div class="device-basicInfo">
                          <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                            <div>
                              <p-skeleton appearance="line" width="70px" height="70px">></p-skeleton>
                            </div>
                          </div>
                          <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                            <div class="device-title">
                              <div class="name">
                                <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 14, 'background-color': '#e9eef0'}"></p-skeleton>
                              </div>
                            </div>
                            <div class="device-desc">
                              <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                            </div>
                          </div>
                        </div>
                        <div class="device-moreInfo" style="display: block !important;">
                          <p-skeleton appearance="line" [theme]="{ 'width': '100%', 'height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                        </div>
                      </div>
                    </div>
                  </div>
              </ng-template>
          </p-virtualscroller>
        </ng-template>
      </p-accordion-panel>
    </p-accordion>
  </div>
  <div class="deviceRow" *ngIf="selectedTab == '0' || selectedTab == '1'">
    <h4 class="typeName device" style="margin: 1em 0 .5em 0;">{{'Device' | translate}} ({{deviceListData.length}})</h4>
    <div class="row" *ngIf="deviceListLength <= 20 else virtualScroll">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" *ngFor="let item of deviceListData; let i=index;">
        <p-blockUI [target]="pnl" *ngIf="item.isExpired && !pageloading && !this.isMsp" [blocked]="item.isExpired && !pageloading">
          <!-- <i class="fa fa-lock fa-5x"></i>
          <div class="tooltips" pTooltip="{{'No valid Plan or trial is available' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
          </div> -->
          <button type="button" pButton (click)="displayisTrialDialog(item);" label="{{'Get Free Trial' | translate}}"
                  class="p-button-rounded" icon="fa fa-lock" *ngIf="item.canTrial && !this.isMsp"></button>
          <button type="button" pButton (click)="displayExpiredDialog(item);" label="{{'Locked' | translate}}"
                  class="p-button-rounded p-button-secondary" icon="fa fa-lock" *ngIf="!item.canTrial && !this.isMsp"></button>
        </p-blockUI>
        <p-blockUI [target]="pnl" *ngIf="!item.isExpired && companionAlert && item.protecting && item.status !== 'offline'" [blocked]="!item.isExpired && companionAlert && item.protecting && item.status !== 'offline'">
          <button type="button" pButton  (click)="routerCompanion();" label="{{'See Companion' | translate}}" class="p-button-rounded ui-button-danger" ></button>
          <div class="share-name">
            <a [routerLink]="item.routeLink" translate style="text-decoration: underline !important;">click here for details.</a>
          </div>
        </p-blockUI>
        <p-panel #pnl class="device_blockUI" [ngClass]="{'trial_block': item.isExpired && item.canTrial, 'companion_block': !item.isExpired && companionAlert && item.protecting && item.status !== 'offline'}">
          <a *ngIf="pageloading">
            <div class="device-content" style="display: block !important;">
              <div class="device-basicInfo">
                <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                  <div>
                    <p-skeleton appearance="line" width="70px" height="70px">></p-skeleton>
                  </div>
                </div>
                <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                  <div class="device-title">
                    <div class="name">
                      <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                    </div>
                  </div>
                  <div class="device-desc">
                    <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                  </div>
                </div>
              </div>
              <div class="device-moreInfo" style="display: block !important;">
                <p-skeleton appearance="line" [theme]="{ 'height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
              </div>
            </div>
          </a>
          <a [routerLink]="item.routeLink" class="device-link" [class.disabled]="item.isExpired ? true : companionAlertitem ? (item.protecting ? (item.status !== 'offline' ? true : null) : null) :null" *ngIf="!pageloading">
            <div class="device-content {{item.status}}">
              <div class="device-basicInfo">
                <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                  <!-- <img src="{{item.image}}" alt="" class="responsive-image"> -->
                  <div class="img-size">
                    <img class="responsive-image" [defaultImage]="'/assets/images/default_device.png'" [lazyLoad]="item.image" (error)="errorHandler($event)">
                    <!-- <img [hidden]="pageloading" (load)="onLoad()" src="{{item.image}}" (error)="errorHandler($event)" class="responsive-image">
                    <img *ngIf="pageloading" src="/assets/images/default_device.png" alt="loading" class="responsive-image"> -->
                  </div>
                </div>
                <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                  <div class="device-title">
                    <div class="name">
                      <!-- <i class="fa {{item.icon}}" aria-hidden="true"></i> -->
                      <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': item.hardwarefault.faultLevelColor}"
                         *ngIf="item.hardwarefault && item.hardwarefault.isHardwareFault"></i>
                      <h5> {{item.name}}</h5>
                    </div>
                    <div class="badge badge-secondary hidden-sm">
                      <span>{{item.displayTag}}</span>
                    </div>
                  </div>
                  <div class="device-desc">{{item.desc | translate}}</div>
                </div>
              </div>
              <div class="device-moreInfo" *ngIf="item.DeviceSubType === DeviceSubTypeMapping['UPS'] || item.DeviceSubType == DeviceSubTypeMapping['3-Phase UPS']">
                <div class="device-battery {{item.batteryStatus}}">
                  <div class="device-icon" pTooltip="{{'Battery Capacity' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                    <p-progressBar [value]="item.batteryCapacity" [showValue]="false"></p-progressBar>
                    <i class="fa fa-battery-empty" aria-hidden="true"></i>
                  </div>
                  <span>{{item.batteryCapacity}} %</span>
                </div>
                <!-- 快到期判斷class=true -->
                <div class="device-rbrd" *ngIf="item.btyReplacement && item.btyReplacement.BR_Rc_Date && item.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'alert-color': item.btyReplacement.expires, 'companion_block': companionAlert && item.protecting && item.status !== 'offline'}">
                  <div class="device-icon">
                    <i *ngIf="item.btyReplacement.expires" class="fa fa-bell" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
                       tooltipStyleClass="critical"></i>
                    <i *ngIf="!item.btyReplacement.expires" class="fa fa-calendar" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
                       tooltipStyleClass="tooltips_gary"></i>
                  </div>
                  <span>{{item.btyReplacement.BR_Rc_Date | date: preferenceService.dateFormat}}</span>
                </div>
                <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                <div class="device-trial" *ngIf="!item.planActivate && !item.mspPlanActivate && !item.isExpired && item.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'companion_block': companionAlert && item.protecting && item.status !== 'offline', 'alert-color': item.trialRemainDay <10}">
                  <div class="device-icon">
                    <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                       tooltipStyleClass="tooltips_gary"></i>
                  </div>
                  <span>{{item.trialRemainDay}}<span translate>days</span></span>
                </div>
              </div>
              <div class="device-moreInfo" *ngIf="item.DeviceSubType == DeviceSubTypeMapping['ATS'] || item.DeviceSubType == DeviceSubTypeMapping['PDU'] || item.DeviceSubType == DeviceSubTypeMapping['nATS'] || item.DeviceSubType == DeviceSubTypeMapping['nPDU']">
                <div class="device-current">
                  <div class="device-icon">
                    <i class="fa fa-bolt" aria-hidden="true" pTooltip="{{'Current' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary"></i>
                  </div>
                  <span>{{item.Cur}} A</span>
                </div>
                <div class="device-energy" *ngIf="item.DeviceSubType === DeviceSubTypeMapping['ATS'] || item.DeviceSubType === DeviceSubTypeMapping['PDU']">
                  <div class="device-icon">
                    <span class="material-icons" pTooltip="{{'Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                      model_training
                    </span>
                  </div>
                  <span *ngIf="item.Energy else noData_span">{{item.Energy}}</span> kWh
                </div>
                <div class="device-energyT" *ngIf="item.DeviceSubType === DeviceSubTypeMapping['nATS'] || item.DeviceSubType === DeviceSubTypeMapping['nPDU']">
                  <div class="device-icon">
                    <span class="material-icons" pTooltip="{{'Total Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                      model_training
                    </span>
                  </div>
                  <span *ngIf="item.EnergyT else noData_span">{{item.EnergyT}}</span> kWh
                </div>
                <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                <div class="device-trial" *ngIf="!item.planActivate && !item.mspPlanActivate && !item.isExpired" [ngClass]="{'companion_block': item.protecting && companionAlert && item.status !== 'offline' , 'alert-color': item.trialRemainDay <10}">
                  <div class="device-icon">
                    <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                        tooltipStyleClass="tooltips_gary"></i>
                  </div>
                  <span>{{item.trialRemainDay}}<span translate>days</span></span>
                </div>
              </div>
            </div>
          </a>
        </p-panel>
      </div>
    </div>
    <div class="row" *ngIf="deviceListLength == 0">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" *ngFor="let item of dataLoadingView">
        <div class="device-content" style="display: block !important;" *ngIf="pageloading">
          <div class="device-basicInfo">
            <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
              <div>
                <p-skeleton appearance="line" width="70px" height="70px">></p-skeleton>
              </div>
            </div>
            <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
              <div class="device-title">
                <div class="name">
                  <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 14, 'background-color': '#e9eef0'}"></p-skeleton>
                </div>
              </div>
              <div class="device-desc">
                <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
              </div>
            </div>
          </div>
          <div class="device-moreInfo" style="display: block !important;">
            <p-skeleton appearance="line" [theme]="{ 'width': '100%', 'height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
          </div>
        </div>
      </div>
    </div>
    <ng-template #virtualScroll>
        <p-virtualscroller [items]="deviceListData" [itemSize]="25" [showLoader]="true" [delay]="250" scrollHeight="550px" [style]="{ height: '550px' }">
            <ng-template #item let-item let-options="options">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 {{i}}">
                <p-blockUI [target]="pnl" *ngIf="item.isExpired && !pageloading && !this.isMsp" [blocked]="item.isExpired && !pageloading">
                  <button type="button" pButton (click)="displayisTrialDialog(item);" label="{{'Get Free Trial' | translate}}"
                          class="p-button-rounded" icon="fa fa-lock" *ngIf="item.canTrial"></button>
                  <button type="button" pButton (click)="displayExpiredDialog(item);" label="{{'Locked' | translate}}"
                          class="p-button-rounded p-button-secondary" icon="fa fa-lock" *ngIf="!item.canTrial && !this.isMsp"></button>
                </p-blockUI>
                <p-panel #pnl class="device_blockUI" [ngClass]="{'trial_block': item.canTrial}">
                  <a [routerLink]="item.routeLink" class="device-link" [class.disabled]="item.isExpired ? true : null" *ngIf="!pageloading">
                    <div class="device-content {{item.status}}">
                      <div class="device-basicInfo">
                        <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                          <!-- <img src="{{item.image}}" alt="" class="responsive-image"> -->
                          <div class="img-size">
                            <img class="responsive-image" [defaultImage]="'/assets/images/default_device.png'" [lazyLoad]="item.image" (error)="errorHandler($event)">
                            <!-- <img [hidden]="pageloading" (load)="onLoad()" src="{{item.image}}" (error)="errorHandler($event)" class="responsive-image">
                            <img *ngIf="pageloading" src="/assets/images/default_device.png" alt="loading" class="responsive-image"> -->
                          </div>
                        </div>
                        <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                          <div class="device-title">
                            <div class="name">
                              <!-- <i class="fa {{item.icon}}" aria-hidden="true"></i> -->
                              <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': item.hardwarefault.faultLevelColor}"
                                *ngIf="item.hardwarefault && item.hardwarefault.isHardwareFault"></i>
                              <h5> {{item.name}}</h5>
                            </div>
                            <div class="badge badge-secondary hidden-sm">
                              <span>{{item.displayTag}}</span>
                            </div>
                          </div>
                          <div class="device-desc">{{item.desc | translate}}</div>
                        </div>
                      </div>
                      <div class="device-moreInfo" *ngIf="item.DeviceSubType === DeviceSubTypeMapping['UPS'] || item.DeviceSubType == DeviceSubTypeMapping['3-Phase UPS']">
                        <div class="device-battery {{item.batteryStatus}}">
                          <div class="device-icon" pTooltip="{{'Battery Capacity' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                            <p-progressBar [value]="item.batteryCapacity" [showValue]="false"></p-progressBar>
                            <i class="fa fa-battery-empty" aria-hidden="true"></i>
                          </div>
                          <span>{{item.batteryCapacity}} %</span>
                        </div>
                        <!-- 快到期判斷class=true -->
                        <div class="device-rbrd" *ngIf="item.btyReplacement && item.btyReplacement.BR_Rc_Date && item.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'alert-color': item.btyReplacement.expires}">
                          <div class="device-icon">
                            <i *ngIf="item.btyReplacement.expires" class="fa fa-bell" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
                              tooltipStyleClass="critical"></i>
                            <i *ngIf="!item.btyReplacement.expires" class="fa fa-calendar" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
                              tooltipStyleClass="tooltips_gary"></i>
                          </div>
                          <span>{{item.btyReplacement.BR_Rc_Date | date: preferenceService.dateFormat}}</span>
                        </div>
                        <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                        <div class="device-trial" *ngIf="!item.planActivate && !item.mspPlanActivate && !item.isExpired && item.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'alert-color': item.trialRemainDay <10}">
                          <div class="device-icon">
                            <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                              tooltipStyleClass="tooltips_gary"></i>
                          </div>
                          <span>{{item.trialRemainDay}}<span translate>days</span></span>
                        </div>
                      </div>
                      <div class="device-moreInfo" *ngIf="item.DeviceSubType == DeviceSubTypeMapping['ATS'] || item.DeviceSubType == DeviceSubTypeMapping['PDU'] || item.DeviceSubType == DeviceSubTypeMapping['nATS'] || item.DeviceSubType == DeviceSubTypeMapping['nPDU']">
                        <div class="device-current">
                          <div class="device-icon">
                            <i class="fa fa-bolt" aria-hidden="true" pTooltip="{{'Current' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary"></i>
                          </div>
                          <span>{{item.Cur}} A</span>
                        </div>
                        <div class="device-energy" *ngIf="item.DeviceSubType === DeviceSubTypeMapping['ATS'] || item.DeviceSubType === DeviceSubTypeMapping['PDU']">
                          <div class="device-icon">
                            <span class="material-icons" pTooltip="{{'Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                              model_training
                            </span>
                          </div>
                          <span *ngIf="item.Energy else noData_span">{{item.Energy}}</span> kWh
                        </div>
                        <div class="device-energyT" *ngIf="item.DeviceSubType === DeviceSubTypeMapping['nATS'] || item.DeviceSubType === DeviceSubTypeMapping['nPDU']">
                          <div class="device-icon">
                            <span class="material-icons" pTooltip="{{'Total Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                              model_training
                            </span>
                          </div>
                          <span *ngIf="item.EnergyT else noData_span">{{item.EnergyT}}</span> kWh
                        </div>
                        <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                        <div class="device-trial" *ngIf="!item.planActivate && !item.mspPlanActivate && !item.isExpired" [ngClass]="{'companion_block': item.protecting && companionAlert && item.status !== 'offline' , 'alert-color': item.trialRemainDay <10}">
                          <div class="device-icon">
                            <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                              tooltipStyleClass="tooltips_gary"></i>
                          </div>
                          <span>{{item.trialRemainDay}}<span translate>days</span></span>
                        </div>
                      </div>
                    </div>
                  </a>
                </p-panel>
              </div>
            </ng-template>
            <ng-template #loader let-options="options">
                <div class="row" style="padding-right: 8px;">
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" *ngFor="let item of dataLoadingView">
                    <div class="device-content" style="display: block !important;">
                      <div class="device-basicInfo">
                        <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                          <div>
                            <p-skeleton appearance="line" width="70px" height="70px">></p-skeleton>
                          </div>
                        </div>
                        <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                          <div class="device-title">
                            <div class="name">
                              <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 14, 'background-color': '#e9eef0'}"></p-skeleton>
                            </div>
                          </div>
                          <div class="device-desc">
                            <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                          </div>
                        </div>
                      </div>
                      <div class="device-moreInfo" style="display: block !important;">
                        <p-skeleton appearance="line" [theme]="{ 'width': '100%', 'height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                      </div>
                    </div>
                  </div>
                </div>
            </ng-template>
        </p-virtualscroller>
    </ng-template>
  </div>
  <div *ngIf="groupFeature && selectedTab == '0' || selectedTab == '4'" class="groupRow">
    <h4 class="typeName" style="margin: 1em 0 .5em 0;">{{'Shared Group' | translate}} ({{deviceShareGroupListData.length}})</h4>
    <p-accordion (onOpen)="onTabOpen($event)">
      <!-- group_share_status這邊須改為判斷group是否為分享的狀態 -->
      <p-accordion-panel [value]="i" *ngFor="let item of deviceShareGroupListData; let i=index;" [disabled]="item.data.share_status === 0">
        <p-accordion-header [ngClass]="{'group_blockUI': item.data.is_shared }">
          <div class="flex" *ngIf="pageloading">
            <a [routerLinkActive]="['is-active']" class="groupLink name">
              <div class="groupName flex">
                <div class="groupIcon">
                  <p-skeleton shape="circle" width="40px" height="40px"></p-skeleton>
                </div>
                <h5 style="margin-top: 12px !important;"><p-skeleton appearance="line" width="200px" height="14px"></p-skeleton></h5>
              </div>
            </a>
            <a class="groupLink info" style="margin-top: 12px !important;"><p-skeleton appearance="line" width="52px" height="14px"></p-skeleton></a>
          </div>
          <div class="flex" *ngIf="!pageloading">
            <div class="button" *ngIf="item.data.share_status === 0">
              <p-button icon="pi pi-times" class="p-btn-outline" (click)="rejectSharedGroup(item);"></p-button>
              <p-button icon="pi pi-check" class="p-btn-fill" (click)="acceptSharedGroup(item);"></p-button>
              <div class="share-name">
                <h5>{{item.data.FirstName}} {{item.data.LastName}}</h5> <span translate>wants to share with you</span>
              </div>
            </div>
            <a [routerLinkActive]="['is-active']" class="groupLink name">
              <div class="groupName">
                <div class="groupIcon {{item.data.status}}">
                  <i class="fa fa-sitemap" aria-hidden="true"></i>
                </div>
                <h5>{{item.data.name}}</h5>
              </div>
            </a>
            <!-- <a class="groupLink info" (click)="triggerEdit(item.data.gId)"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
            <a class="groupLink info" (click)="triggerDelete(item.data.gId)"><i class="fa fa-trash"
                 aria-hidden="true"></i></a> -->
            <a routerLink="{{item.data.routeLink}}" [routerLinkActive]="['is-active']" class="groupLink info"><i
                 class="fa fa-info-circle"
                 aria-hidden="true"></i></a>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="row" *ngIf="filterChildren(item.children,true).length <= 20 else deviceSharingGroupListVirtualScroll">
            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12" *ngFor="let item of filterChildren(item.children,true); let i=index;">
              <p-blockUI [target]="pnl" *ngIf="item.data.isExpired && !this.isMsp" [blocked]="item.data.isExpired">
                <!-- <i class="fa fa-lock fa-5x"></i>
                <div class="tooltips" pTooltip="{{'No valid Plan or trial is available' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                </div> -->
                <button type="button" pButton (click)="displayisTrialDialog(item.data);" label="{{'Get Free Trial' | translate}}"
                        class="p-button-rounded" icon="fa fa-lock" *ngIf="item.data.canTrial && !this.isMsp"></button>
                <button type="button" pButton (click)="displayExpiredDialog(item.data);" label="{{'Locked' | translate}}"
                        class="p-button-rounded p-button-secondary" icon="fa fa-lock" *ngIf="!item.data.canTrial && !this.isMsp"></button>
              </p-blockUI>
              <p-blockUI [target]="pnl" *ngIf="!item.data.isExpired && companionAlert && item.data.protecting && item.data.status !== 'offline'" [blocked]="!item.data.isExpired && companionAlert && item.data.protecting && item.data.status !== 'offline'">
                <button type="button" pButton  (click)="routerCompanion();" label="{{'See Companion' | translate}}" class="p-button-rounded ui-button-danger" ></button>
                <div class="share-name">
                  <a [routerLink]="item.data.routeLink" translate style="text-decoration: underline !important;">click here for details.</a>
                </div>
              </p-blockUI>
              <p-panel #pnl class="device_blockUI" [ngClass]="{'trial_block': item.data.isExpired && item.data.canTrial && !this.isMsp, 'companion_block': !item.data.isExpired && companionAlert && item.data.protecting && item.data.status !== 'offline'}">
                <a [routerLink]="item.data.routeLink" class="device-link" [class.disabled]="!this.isMsp && item.data.isExpired ? true : item.data.protecting ? (item.data.status !== 'offline' ? true : null) : null">
                  <div class="device-content {{item.data.status}}">
                    <div class="device-basicInfo">
                      <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                        <!-- <img src="{{item.image}}" alt="" class="responsive-image"> -->
                        <div class="img-size">
                          <img class="responsive-image" [defaultImage]="'/assets/images/default_device.png'" [lazyLoad]="item.data.image" (error)="errorHandler($event)">
                          <!-- <img [hidden]="pageloading" (load)="onLoad()" src="{{item.data.image}}" onerror="this.src='/assets/images/default_device.png'"
                              class="responsive-image">
                          <img *ngIf="pageloading" src="/assets/images/default_device.png" alt="loading" class="responsive-image"> -->
                        </div>
                      </div>
                      <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                        <div class="device-title">
                          <div class="name">
                            <!-- <i class="fa {{item.icon}}" aria-hidden="true"></i> -->
                            <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': item.data.hardwarefault.faultLevelColor}"
                              *ngIf="item.data.hardwarefault && item.data.hardwarefault.isHardwareFault"></i>
                            <h5> {{item.data.name}}</h5>
                          </div>
                          <div class="badge badge-secondary hidden-sm">
                            <span>{{item.data.displayTag}}</span>
                          </div>
                        </div>
                        <div class="device-desc">{{item.data.desc | translate}}</div>
                      </div>
                    </div>
                    <div class="device-moreInfo" *ngIf="item.data.DeviceSubType === DeviceSubTypeMapping['UPS'] || item.data.DeviceSubType == DeviceSubTypeMapping['3-Phase UPS']">
                      <div class="device-battery {{item.data.batteryStatus}}">
                        <div class="device-icon" pTooltip="{{'Battery Capacity' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                          <p-progressBar [value]="item.data.batteryCapacity" [showValue]="false"></p-progressBar>
                          <i class="fa fa-battery-empty" aria-hidden="true"></i>
                        </div>
                        <span>{{item.data.batteryCapacity}} %</span>
                      </div>
                      <!-- 快到期判斷class=true -->
                      <div class="device-rbrd" *ngIf="item.data.btyReplacement && item.data.btyReplacement.BR_Rc_Date && item.data.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'companion_block': item.data.protecting && companionAlert && item.data.status !== 'offline' , 'alert-color': item.data.btyReplacement.expires}">
                        <div class="device-icon">
                          <i *ngIf="item.data.btyReplacement.expires" class="fa fa-bell" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
                            tooltipStyleClass="critical"></i>
                          <i *ngIf="!item.data.btyReplacement.expires" class="fa fa-calendar" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}"
                            tooltipPosition="bottom" tooltipStyleClass="tooltips_gary"></i>
                        </div>
                        <span>{{item.data.btyReplacement.BR_Rc_Date | date: preferenceService.dateFormat}}</span>
                      </div>
                      <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                      <div class="device-trial" *ngIf="!item.data.planActivate && !item.data.mspPlanActivate && !item.data.isExpired && item.data.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'companion_block': item.data.protecting && companionAlert && item.data.status !== 'offline' , 'alert-color': item.data.trialRemainDay <10}">
                        <div class="device-icon">
                          <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                            tooltipStyleClass="tooltips_gary"></i>
                        </div>
                        <span>{{item.data.trialRemainDay}}<span translate>days</span></span>
                      </div>
                    </div>
                    <div class="device-moreInfo" *ngIf="item.data.DeviceSubType == DeviceSubTypeMapping['ATS'] || item.data.DeviceSubType == DeviceSubTypeMapping['PDU'] || item.data.DeviceSubType == DeviceSubTypeMapping['nATS'] || item.data.DeviceSubType == DeviceSubTypeMapping['nPDU']">
                      <div class="device-current">
                        <div class="device-icon">
                          <i class="fa fa-bolt" aria-hidden="true" pTooltip="{{'Current' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary"></i>
                        </div>
                        <span>{{item.data.Cur}} A</span>
                      </div>
                      <div class="device-energy" *ngIf="item.data.DeviceSubType === DeviceSubTypeMapping['ATS'] || item.data.DeviceSubType === DeviceSubTypeMapping['PDU']">
                        <div class="device-icon">
                          <span class="material-icons" pTooltip="{{'Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                            model_training
                          </span>
                        </div>
                        <span *ngIf="item.data.Energy else noData_span">{{item.data.Energy}}</span> kWh
                      </div>
                      <div class="device-energyT" *ngIf="item.data.DeviceSubType === DeviceSubTypeMapping['nATS'] || item.data.DeviceSubType === DeviceSubTypeMapping['nPDU']">
                        <div class="device-icon">
                          <span class="material-icons" pTooltip="{{'Total Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                            model_training
                          </span>
                        </div>
                        <span *ngIf="item.data.EnergyT else noData_span">{{item.data.EnergyT}}</span> kWh
                      </div>
                      <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                      <div class="device-trial" *ngIf="!item.data.planActivate && !item.data.mspPlanActivate && !item.data.isExpired" [ngClass]="{'companion_block': item.data.protecting && companionAlert && item.data.status !== 'offline' , 'alert-color': item.data.trialRemainDay <10}">
                        <div class="device-icon">
                          <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                            tooltipStyleClass="tooltips_gary"></i>
                        </div>
                        <span>{{item.data.trialRemainDay}}<span translate>days</span></span>
                      </div>
                    </div>
                  </div>
                </a>
              </p-panel>
            </div>
          </div>
          <div class="row" *ngIf="filterChildren(item.children,true).length == 0">
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" *ngFor="let item of dataLoadingView">
              <div class="device-content" style="display: block !important;" *ngIf="pageloading">
                <div class="device-basicInfo">
                  <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                    <div>
                      <p-skeleton appearance="line" width="70px" height="70px">></p-skeleton>
                    </div>
                  </div>
                  <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                    <div class="device-title">
                      <div class="name">
                        <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 14, 'background-color': '#e9eef0'}"></p-skeleton>
                      </div>
                    </div>
                    <div class="device-desc">
                      <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                    </div>
                  </div>
                </div>
                <div class="device-moreInfo" style="display: block !important;">
                  <p-skeleton appearance="line" [theme]="{ 'width': '100%', 'height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </p-accordion-content>
        <ng-template #deviceSharingGroupListVirtualScroll>
          <p-virtualscroller [items]="filterChildrenItemShared" [itemSize]="25" [showLoader]="true" [delay]="250" scrollHeight="550px" [style]="{ height: '550px' }">
              <ng-template #item let-item let-options="options">
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12">
                <p-blockUI [target]="pnl" *ngIf="item.data.isExpired && !this.isMsp" [blocked]="item.data.isExpired">
                  <!-- <i class="fa fa-lock fa-5x"></i>
                  <div class="tooltips" pTooltip="{{'No valid Plan or trial is available' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                  </div> -->
                  <button type="button" pButton (click)="displayisTrialDialog(item.data);" label="{{'Get Free Trial' | translate}}"
                          class="p-button-rounded" icon="fa fa-lock" *ngIf="item.data.canTrial && !this.isMsp"></button>
                  <button type="button" pButton (click)="displayExpiredDialog(item.data);" label="{{'Locked' | translate}}"
                          class="p-button-rounded p-button-secondary" icon="fa fa-lock" *ngIf="!item.data.canTrial && !this.isMsp"></button>
                </p-blockUI>
                <p-panel #pnl class="device_blockUI" [ngClass]="{'trial_block': item.data.canTrial}">
                  <a [routerLink]="item.data.routeLink" class="device-link" [class.disabled]="item.data.isExpired ? true : null">
                    <div class="device-content {{item.data.status}}">
                      <div class="device-basicInfo">
                        <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                          <!-- <img src="{{item.image}}" alt="" class="responsive-image"> -->
                          <div class="img-size">
                            <img class="responsive-image" [defaultImage]="'/assets/images/default_device.png'" [lazyLoad]="item.data.image" (error)="errorHandler($event)">
                            <!-- <img [hidden]="pageloading" (load)="onLoad()" src="{{item.data.image}}" onerror="this.src='/assets/images/default_device.png'"
                                 class="responsive-image">
                            <img *ngIf="pageloading" src="/assets/images/default_device.png" alt="loading" class="responsive-image"> -->
                          </div>
                        </div>
                        <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                          <div class="device-title">
                            <div class="name">
                              <!-- <i class="fa {{item.icon}}" aria-hidden="true"></i> -->
                              <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': item.data.hardwarefault.faultLevelColor}"
                                 *ngIf="item.data.hardwarefault && item.data.hardwarefault.isHardwareFault"></i>
                              <h5> {{item.data.name}}</h5>
                            </div>
                            <div class="badge badge-secondary hidden-sm">
                              <span>{{item.data.displayTag}}</span>
                            </div>
                          </div>
                          <div class="device-desc">{{item.data.desc | translate}}</div>
                        </div>
                      </div>
                      <div class="device-moreInfo" *ngIf="item.data.DeviceSubType === DeviceSubTypeMapping['UPS'] || item.data.DeviceSubType == DeviceSubTypeMapping['3-Phase UPS']">
                        <div class="device-battery {{item.data.batteryStatus}}">
                          <div class="device-icon" pTooltip="{{'Battery Capacity' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                            <p-progressBar [value]="item.data.batteryCapacity" [showValue]="false"></p-progressBar>
                            <i class="fa fa-battery-empty" aria-hidden="true"></i>
                          </div>
                          <span>{{item.data.batteryCapacity}} %</span>
                        </div>
                        <!-- 快到期判斷class=true -->
                        <div class="device-rbrd" *ngIf="item.data.btyReplacement && item.data.btyReplacement.BR_Rc_Date && item.data.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'alert-color': item.data.btyReplacement.expires}">
                          <div class="device-icon">
                            <i *ngIf="item.data.btyReplacement.expires" class="fa fa-bell" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
                               tooltipStyleClass="critical"></i>
                            <i *ngIf="!item.data.btyReplacement.expires" class="fa fa-calendar" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}"
                               tooltipPosition="bottom" tooltipStyleClass="tooltips_gary"></i>
                          </div>
                          <span>{{item.data.btyReplacement.BR_Rc_Date | date: preferenceService.dateFormat}}</span>
                        </div>
                        <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                        <div class="device-trial" *ngIf="!item.data.planActivate && !item.data.mspPlanActivate && !item.data.isExpired && item.data.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'alert-color': item.data.trialRemainDay <10}">
                          <div class="device-icon">
                            <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                               tooltipStyleClass="tooltips_gary"></i>
                          </div>
                          <span>{{item.data.trialRemainDay}}<span translate>days</span></span>
                        </div>
                      </div>
                      <div class="device-moreInfo" *ngIf="item.data.DeviceSubType == DeviceSubTypeMapping['ATS'] || item.data.DeviceSubType == DeviceSubTypeMapping['PDU'] || item.data.DeviceSubType == DeviceSubTypeMapping['nATS'] || item.data.DeviceSubType == DeviceSubTypeMapping['nPDU']">
                        <div class="device-current">
                          <div class="device-icon">
                            <i class="fa fa-bolt" aria-hidden="true" pTooltip="{{'Current' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary"></i>
                          </div>
                          <span>{{item.data.Cur}} A</span>
                        </div>
                        <div class="device-energy" *ngIf="item.data.DeviceSubType === DeviceSubTypeMapping['ATS'] || item.data.DeviceSubType === DeviceSubTypeMapping['PDU']">
                          <div class="device-icon">
                            <span class="material-icons" pTooltip="{{'Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                              model_training
                            </span>
                          </div>
                          <span *ngIf="item.data.Energy else noData_span">{{item.data.Energy}}</span> kWh
                        </div>
                        <div class="device-energyT" *ngIf="item.data.DeviceSubType === DeviceSubTypeMapping['nATS'] || item.data.DeviceSubType === DeviceSubTypeMapping['nPDU']">
                          <div class="device-icon">
                            <span class="material-icons" pTooltip="{{'Total Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                              model_training
                            </span>
                          </div>
                          <span *ngIf="item.data.EnergyT else noData_span">{{item.data.EnergyT}}</span> kWh
                        </div>
                        <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                        <div class="device-trial" *ngIf="!item.data.planActivate && !item.data.mspPlanActivate && !item.data.isExpired" [ngClass]="{'companion_block': item.data.protecting && companionAlert && item.data.status !== 'offline' , 'alert-color': item.data.trialRemainDay <10}">
                          <div class="device-icon">
                            <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                              tooltipStyleClass="tooltips_gary"></i>
                          </div>
                          <span>{{item.data.trialRemainDay}}<span translate>days</span></span>
                        </div>
                      </div>
                    </div>
                  </a>
                </p-panel>
              </div>
              </ng-template>
              <ng-template #loader let-options="options">
                  <div class="row" style="padding-right: 8px;">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" *ngFor="let item of dataLoadingView">
                      <div class="device-content" style="display: block !important;">
                        <div class="device-basicInfo">
                          <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                            <div>
                              <p-skeleton appearance="line" width="70px" height="70px">></p-skeleton>
                            </div>
                          </div>
                          <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                            <div class="device-title">
                              <div class="name">
                                <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 14, 'background-color': '#e9eef0'}"></p-skeleton>
                              </div>
                            </div>
                            <div class="device-desc">
                              <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                            </div>
                          </div>
                        </div>
                        <div class="device-moreInfo" style="display: block !important;">
                          <p-skeleton appearance="line" [theme]="{ 'width': '100%', 'height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                        </div>
                      </div>
                    </div>
                  </div>
              </ng-template>
          </p-virtualscroller>
        </ng-template>
      </p-accordion-panel>
    </p-accordion>
  </div>
  <div *ngIf="selectedTab == '0' ||  selectedTab == '3'">
    <h4 class="typeName device" style="margin: 1em 0 .5em 0;">{{'Shared Device' | translate}} ({{deviceSharingListData.length}})</h4>
    <div class="deviceRow">
      <div class="row" *ngIf="deviceSharingListLength <= 20 else deviceSharingListVirtualScroll">
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" *ngFor="let item of deviceSharingListData; let i=index;">
          <p-blockUI [target]="pnl" *ngIf="item.share_status === 0" [blocked]="item.share_status === 0">
            <div class="button center">
              <p-button icon="pi pi-times" class="p-btn-outline" (click)="rejectShareDevice(item);"></p-button>
              <p-button icon="pi pi-check" class="p-btn-fill" (click)="acceptShareDvice(item);"></p-button>
              <div class="share-name">
                <h5>{{item.FirstName}} {{item.LastName}}</h5> <span translate>wants to share with you</span>
              </div>
            </div>
          </p-blockUI>
          <p-panel #pnl class="device_blockUI" [ngClass]="{'trial_block': !item.canTrial && item.isExpired, 'share_block': true, 'companion_block': companionAlert && item.protecting && !item.isExpired && item.status !== 'offline'}">
            <a [routerLink]="item.routeLink" class="device-link" [class.disabled]="item.isExpired ? true : companionAlertitem ? (item.protecting ? (item.status !== 'offline' ? true : null) : null) : null">
              <div class="device-content {{item.status}}">
                <div class="device-basicInfo">
                  <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                    <!-- <img src="{{item.image}}" alt="" class="responsive-image"> -->
                    <div class="img-size">
                      <img class="responsive-image" [defaultImage]="'/assets/images/default_device.png'" [lazyLoad]="item.image" (error)="errorHandler($event)">
                      <!-- <img [hidden]="pageloading" (load)="onLoad()" src="{{item.image}}" (error)="errorHandler($event)" class="responsive-image">
                      <img *ngIf="pageloading" src="/assets/images/default_device.png" alt="loading" class="responsive-image"> -->
                    </div>
                  </div>
                  <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                    <div class="device-title">
                      <div class="name">
                        <!-- <i class="fa {{item.icon}}" aria-hidden="true"></i> -->
                        <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': item.hardwarefault.faultLevelColor}"
                           *ngIf="item.hardwarefault && item.hardwarefault.isHardwareFault"></i>
                        <h5> {{item.name}}</h5>
                      </div>
                      <div class="badge badge-secondary hidden-sm">
                        <span>{{item.displayTag}}</span>
                      </div>
                    </div>
                    <div class="device-desc">{{item.desc | translate}}</div>
                  </div>
                </div>
                <div class="device-moreInfo" *ngIf="item.DeviceSubType === DeviceSubTypeMapping['UPS'] || item.DeviceSubType == DeviceSubTypeMapping['3-Phase UPS']">
                  <div class="device-battery {{item.batteryStatus}}">
                    <div class="device-icon" pTooltip="{{'Battery Capacity' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                      <p-progressBar [value]="item.batteryCapacity" [showValue]="false"></p-progressBar>
                      <i class="fa fa-battery-empty" aria-hidden="true"></i>
                    </div>
                    <span>{{item.batteryCapacity}} %</span>
                  </div>
                  <!-- 快到期判斷class=true -->
                  <div class="device-rbrd" *ngIf="item.btyReplacement && item.btyReplacement.BR_Rc_Date && item.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'alert-color': item.btyReplacement.expires, 'companion_block': companionAlert && item.protecting && item.status !== 'offline'}">
                    <div class="device-icon">
                      <i *ngIf="item.btyReplacement.expires" class="fa fa-bell" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
                         tooltipStyleClass="critical"></i>
                      <i *ngIf="!item.btyReplacement.expires" class="fa fa-calendar" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
                         tooltipStyleClass="tooltips_gary"></i>
                    </div>
                    <span>{{item.btyReplacement.BR_Rc_Date | date: preferenceService.dateFormat}}</span>
                  </div>
                  <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                  <div class="device-trial" *ngIf="!item.planActivate && !item.mspPlanActivate && !item.isExpired && item.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'companion_block': companionAlert && item.protecting && item.status !== 'offline', 'alert-color': item.trialRemainDay <10}">
                    <div class="device-icon">
                      <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                         tooltipStyleClass="tooltips_gary"></i>
                    </div>
                    <span>{{item.trialRemainDay}}<span translate>days</span></span>
                  </div>
                </div>
                <div class="device-moreInfo" *ngIf="item.DeviceSubType == DeviceSubTypeMapping['ATS'] || item.DeviceSubType == DeviceSubTypeMapping['PDU'] || item.DeviceSubType == DeviceSubTypeMapping['nATS'] || item.DeviceSubType == DeviceSubTypeMapping['nPDU']">
                  <div class="device-current">
                    <div class="device-icon">
                      <i class="fa fa-bolt" aria-hidden="true" pTooltip="{{'Current' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary"></i>
                    </div>
                    <span>{{item.Cur}} A</span>
                  </div>
                  <div class="device-energy" *ngIf="item.DeviceSubType === DeviceSubTypeMapping['ATS'] || item.DeviceSubType === DeviceSubTypeMapping['PDU']">
                    <div class="device-icon">
                      <span class="material-icons" pTooltip="{{'Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                        model_training
                      </span>
                    </div>
                    <span *ngIf="item.Energy else noData_span">{{item.Energy}}</span> kWh
                  </div>
                  <div class="device-energyT" *ngIf="item.DeviceSubType === DeviceSubTypeMapping['nATS'] || item.DeviceSubType === DeviceSubTypeMapping['nPDU']">
                    <div class="device-icon">
                      <span class="material-icons" pTooltip="{{'Total Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                        model_training
                      </span>
                    </div>
                    <span *ngIf="item.EnergyT else noData_span">{{item.EnergyT}}</span> kWh
                  </div>
                  <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                  <div class="device-trial" *ngIf="!item.planActivate && !item.mspPlanActivate && !item.isExpired" [ngClass]="{'companion_block': item.protecting && companionAlert && item.status !== 'offline' , 'alert-color': item.trialRemainDay <10}">
                    <div class="device-icon">
                      <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                          tooltipStyleClass="tooltips_gary"></i>
                    </div>
                    <span>{{item.trialRemainDay}}<span translate>days</span></span>
                  </div>
                </div>
              </div>
            </a>
          </p-panel>
        </div>
      </div>
      <div class="row" *ngIf="deviceSharingListLength == 0">
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" *ngFor="let item of dataLoadingView">
          <div class="device-content" style="display: block !important;" *ngIf="pageloading">
            <div class="device-basicInfo">
              <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                <div>
                  <p-skeleton appearance="line" width="70px" height="70px"></p-skeleton>
                </div>
              </div>
              <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                <div class="device-title">
                  <div class="name">
                    <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 14, 'background-color': '#e9eef0'}"></p-skeleton>
                  </div>
                </div>
                <div class="device-desc">
                  <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                </div>
              </div>
            </div>
            <div class="device-moreInfo" style="display: block !important;">
              <p-skeleton appearance="line" [theme]="{ 'width': '100%', 'height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
      <ng-template #deviceSharingListVirtualScroll>
          <p-virtualscroller [items]="deviceSharingListData" [itemSize]="25" [showLoader]="true" [delay]="250" scrollHeight="550px" [style]="{ height: '550px' }">
              <ng-template #item let-item let-options="options">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                  <p-blockUI [target]="pnl" *ngIf="item.share_status === 0 && !pageloading" [blocked]="item.share_status === 0 && !pageloading">
                    <div class="button center">
                      <p-button icon="pi pi-times" class="p-btn-outline" (click)="rejectShareDevice(item);"></p-button>
                      <p-button icon="pi pi-check" class="p-btn-fill" (click)="acceptShareDvice(item);"></p-button>
                      <div class="share-name">
                        <h5>{{item.FirstName}} {{item.LastName}}</h5> <span translate>wants to share with you</span>
                      </div>
                    </div>
                  </p-blockUI>
                  <p-panel #pnl class="device_blockUI" [ngClass]="{'trial_block': !item.canTrial, 'share_block': true}">
                    <a *ngIf="pageloading">
                      <div class="device-content" style="display: block !important;">
                        <div class="device-basicInfo">
                          <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                            <div>
                              <p-skeleton appearance="line" width="70px" height="70px">></p-skeleton>
                            </div>
                          </div>
                          <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                            <div class="device-title">
                              <div class="name">
                                <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 14, 'background-color': '#e9eef0'}"></p-skeleton>
                              </div>
                            </div>
                            <div class="device-desc">
                              <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                            </div>
                          </div>
                        </div>
                        <div class="device-moreInfo" style="display: block !important;">
                          <p-skeleton appearance="line" [theme]="{ 'width': '100%', 'height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                        </div>
                      </div>
                    </a>
                    <a [routerLink]="item.routeLink" class="device-link" [class.disabled]="item.isExpired ? true : null" *ngIf="!pageloading">
                      <div class="device-content {{item.status}}">
                        <div class="device-basicInfo">
                          <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                            <!-- <img src="{{item.image}}" alt="" class="responsive-image"> -->
                            <div class="img-size">
                              <img class="responsive-image" [defaultImage]="'/assets/images/default_device.png'" [lazyLoad]="item.image" (error)="errorHandler($event)">
                              <!-- <img [hidden]="pageloading" (load)="onLoad()" src="{{item.image}}" (error)="errorHandler($event)" class="responsive-image">
                              <img *ngIf="pageloading" src="/assets/images/default_device.png" alt="loading" class="responsive-image"> -->
                            </div>
                          </div>
                          <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                            <div class="device-title">
                              <div class="name">
                                <!-- <i class="fa {{item.icon}}" aria-hidden="true"></i> -->
                                <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': item.hardwarefault.faultLevelColor}"
                                  *ngIf="item.hardwarefault && item.hardwarefault.isHardwareFault"></i>
                                <h5> {{item.name}}</h5>
                              </div>
                              <div class="badge badge-secondary hidden-sm">
                                <span>{{item.displayTag}}</span>
                              </div>
                            </div>
                            <div class="device-desc">{{item.desc | translate}}</div>
                          </div>
                        </div>
                        <div class="device-moreInfo" *ngIf="item.DeviceSubType === DeviceSubTypeMapping['UPS'] || item.DeviceSubType == DeviceSubTypeMapping['3-Phase UPS']">
                          <div class="device-current">
                            <div class="device-icon" pTooltip="{{'Battery Capacity' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                              <p-progressBar [value]="item.batteryCapacity" [showValue]="false"></p-progressBar>
                              <i class="fa fa-battery-empty" aria-hidden="true"></i>
                            </div>
                            <span>{{item.batteryCapacity}} %</span>
                          </div>
                          <!-- 快到期判斷class=true -->
                          <div class="device-rbrd" *ngIf="item.btyReplacement && item.btyReplacement.BR_Rc_Date && item.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'alert-color': item.btyReplacement.expires}">
                            <div class="device-icon">
                              <i *ngIf="item.btyReplacement.expires" class="fa fa-bell" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
                                tooltipStyleClass="critical"></i>
                              <i *ngIf="!item.btyReplacement.expires" class="fa fa-calendar" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
                                tooltipStyleClass="tooltips_gary"></i>
                            </div>
                            <span>{{item.btyReplacement.BR_Rc_Date | date: preferenceService.dateFormat}}</span>
                          </div>
                          <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                          <div class="device-trial" *ngIf="!item.planActivate && !item.mspPlanActivate && !item.isExpired && item.DeviceSubType !== DeviceSubTypeMapping['3-Phase UPS']" [ngClass]="{'alert-color': item.trialRemainDay <10}">
                            <div class="device-icon">
                              <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                                tooltipStyleClass="tooltips_gary"></i>
                            </div>
                            <span>{{item.trialRemainDay}}<span translate>days</span></span>
                          </div>
                        </div>
                        <div class="device-moreInfo" *ngIf="item.DeviceSubType == DeviceSubTypeMapping['ATS'] || item.DeviceSubType == DeviceSubTypeMapping['PDU'] || item.DeviceSubType == DeviceSubTypeMapping['nATS'] || item.DeviceSubType == DeviceSubTypeMapping['nPDU']">
                          <div class="device-current">
                            <div class="device-icon">
                              <i class="fa fa-bolt" aria-hidden="true" pTooltip="{{'Current' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary"></i>
                            </div>
                            <span>{{item.Cur}} A</span>
                          </div>
                          <div class="device-energy" *ngIf="item.DeviceSubType === DeviceSubTypeMapping['ATS'] || item.DeviceSubType === DeviceSubTypeMapping['PDU']">
                            <div class="device-icon">
                              <span class="material-icons" pTooltip="{{'Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                                model_training
                              </span>
                            </div>
                            <span *ngIf="item.Energy else noData_span">{{item.Energy}}</span> kWh
                          </div>
                          <div class="device-energyT" *ngIf="item.DeviceSubType === DeviceSubTypeMapping['nATS'] || item.DeviceSubType === DeviceSubTypeMapping['nPDU']">
                            <div class="device-icon">
                              <span class="material-icons" pTooltip="{{'Total Energy' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                                model_training
                              </span>
                            </div>
                            <span *ngIf="item.EnergyT else noData_span">{{item.EnergyT}}</span> kWh
                          </div>
                          <!-- Trial 剩餘天數小於10天時變紅色 class=true -->
                          <div class="device-trial" *ngIf="!item.planActivate && !item.mspPlanActivate && !item.isExpired" [ngClass]="{'companion_block': item.protecting && companionAlert && item.status !== 'offline' , 'alert-color': item.trialRemainDay <10}">
                            <div class="device-icon">
                              <i class="fa fa-unlock" aria-hidden="true" pTooltip="{{'Trial Remaining Days' | translate}}" tooltipPosition="bottom"
                                tooltipStyleClass="tooltips_gary"></i>
                            </div>
                            <span>{{item.trialRemainDay}}<span translate>days</span></span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </p-panel>
                </div>
              </ng-template>
              <ng-template #loader let-options="options">
                  <div class="row" style="padding-right: 8px;">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" *ngFor="let item of dataLoadingView">
                      <div class="device-content" style="display: block !important;">
                        <div class="device-basicInfo">
                          <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                            <div>
                              <p-skeleton appearance="line" width="70px" height="70px">></p-skeleton>
                            </div>
                          </div>
                          <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                            <div class="device-title">
                              <div class="name">
                                <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 14, 'background-color': '#e9eef0'}"></p-skeleton>
                              </div>
                            </div>
                            <div class="device-desc">
                              <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                            </div>
                          </div>
                        </div>
                        <div class="device-moreInfo" style="display: block !important;">
                          <p-skeleton appearance="line" [theme]="{ 'width': '100%', 'height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                        </div>
                      </div>
                    </div>
                  </div>
              </ng-template>
          </p-virtualscroller>
      </ng-template>
    </div>
  </div>
</section>


<app-edit-group></app-edit-group>
<app-delete-group></app-delete-group>
<app-dialog></app-dialog>

<ng-template #noData_span>
  <span>--</span>
</ng-template>

<p-toast [style]="{marginTop: '70px'}"></p-toast>
